<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_7"></a>TO THE INDISPENSABLE:</p>
<p class="dedication1">Cory Doctorow, Phyllis Gotlieb, Sally McBride,<br/>David Nickle, Helen Rykens, Sara Simmons,<br/>Michael Skeet, Hugh A. D. Spencer, Dale Sproule,<br/>Allan Weiss, and Theresa Wojtasiewicz<a id="page_8"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?101fbe71